import { render, staticRenderFns } from "./voaform-fiserv.vue?vue&type=template&id=6a70c46f&scoped=true"
import script from "./voaform-fiserv.vue?vue&type=script&lang=js"
export * from "./voaform-fiserv.vue?vue&type=script&lang=js"
import style0 from "./voaform-fiserv.vue?vue&type=style&index=0&id=6a70c46f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a70c46f",
  null
  
)

export default component.exports